import React, { useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtListRow from "../../components/NtListRow";
import NtModal from "../../components/NtModal";
import NtBadge from "../../components/NtBadge";
import NtDialplanForm from "./NtDialplanForm";

function NtDialplanItem({ item, columns, onUpdate, onDelete }) {
  const updateModalRef = useRef();

  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(row, column) => {
          if (column === "dialplan_enabled") {
            return (
              <NtBadge variant={row[column] === false ? "gray" : "green"}>
                {row[column] === false ? "Disabled" : "Active"}
              </NtBadge>
            );
          }
        }}
        onActionPress={() => updateModalRef.current?.show()}
      />

      <NtModal ref={updateModalRef}>
        <NtDialplanForm
          item={item}
          onCancel={() => updateModalRef.current?.dismiss()}
          onSave={() => {
            updateModalRef.current?.dismiss();
            onUpdate?.();
          }}
          onDelete={() => {
            updateModalRef.current?.dismiss();
            onDelete?.();
          }}
        />
      </NtModal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtDialplanItem;
